import { Card, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React from 'react'
import { CONFIGURACIONTURNOS_PERMISOS } from '../../../utils/permisos';
import { Delete, Edit } from '@material-ui/icons';
import { efectorHorarioSeleccionar, efectorHorariosUpdateDisabled, eliminarHorariosMedicos } from '../../../actions/turnos/efectorHorarios';
import { useDispatch } from 'react-redux';

const style = {
    cell: {
        padding: 8,
        textAlign: 'center',
    },
    cellTime: {
        padding: 8,
        letterSpacing: -1,
        textAlign: 'center',
    },
    iconButton: {
        width: 32,
        height: 32,
        padding: 0,
        marginTop: 0,
        marginBottom: 0,
    },
};


const formatTime = time => {
    return time.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
}

export const ListaHorarios = (props) => {

    const dispatch = useDispatch();

    const { setearVariosValores, setSelectedDays, setEditRegistro, validarSoloUnPermiso, permisosUser, items, cargada } = props;

    const handleEditItem = item => {
        console.log(item)
        dispatch(efectorHorariosUpdateDisabled(true));
        dispatch(efectorHorarioSeleccionar(item));
        setearVariosValores(item);
        setSelectedDays([item.dia]);
        setEditRegistro(true);
        if (!item.generacionInicial)
            dispatch(efectorHorariosUpdateDisabled(false));
    }

    const handleDeleteItem = (item) => {
        const parametros = {
            id: item.id,
            idEfector: item.idEfector,
            idCentro: item.idCentro,
            idEspecialidad: item.idEspecialidad,
        } 
        dispatch(eliminarHorariosMedicos(parametros));
    }

    console.log("item", items)
    return (
        <>
            {cargada &&
                <Card >
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">Dia</TableCell>
                                    <TableCell align="left">Hora Inicio</TableCell>
                                    <TableCell align="left">Hora Fin</TableCell>
                                    <TableCell align="left" style={style.cell}>Teleconsulta</TableCell>
                                    <TableCell align="left" style={style.cell}>Piso</TableCell> {/* 4 caracteres numericos */}
                                    <TableCell align="left" style={style.cell}>Consultorio</TableCell> {/* alfanumerico */}
                                    <TableCell align="left" style={style.cell}>Recepcion</TableCell> {/* alfanumerico */}
                                    <TableCell align="left"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0
                                    ?
                                    // items.map((item) => (
                                    items.sort((a, b) => new Date(a.fechaInicio) - new Date(b.fechaInicio)).map((item) => {
                                        return (
                                            <TableRow key={item.id}>
                                                <TableCell align="left" style={style.cell}>
                                                    <IconButton style={{ padding: 0, margin: 0 }}
                                                        onClick={(e) => handleEditItem(item)}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        color="primary"
                                                        aria-label="Editar"
                                                    >
                                                        <Edit style={style.iconButton} />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.dia}
                                                </TableCell>
                                                <TableCell align="left" style={style.cellTime}>
                                                    {`${formatTime(item.horaDesde)} : ${formatTime(item.minDesde)}`}
                                                </TableCell>
                                                <TableCell align="left" style={style.cellTime}>
                                                    {`${formatTime(item.horaHasta)} : ${formatTime(item.minHasta)}`}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    <Checkbox
                                                        name="presencial"
                                                        checked={item.teleconsulta}
                                                        disabled={true}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.piso}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.consultorio}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    {item.recepcion}
                                                </TableCell>
                                                <TableCell align="left" style={style.cell}>
                                                    <IconButton style={{ padding: 0, margin: 0 }}
                                                        onClick={(e) => handleDeleteItem(item)}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        color="primary"
                                                        aria-label="Eliminar"
                                                    >
                                                        <Delete style={style.iconButton} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                    :
                                    <TableRow style={{ height: 50 }}>
                                        <TableCell colSpan={12} style={{ textAlign: '-webkit-center' }}> Sin Registros</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            }
        </>
    )
}
